<div
    class="pex-dialog"
    (click)="clickOutside($event)"
    (window:keydown.Escape)="escapePressed($event)"
    [style.z-index]="priority + 1000"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <!-- <div tabindex="0" style="position: absolute"></div> -->
    <div
        role="dialog"
        class="pex-dialog-content"
        (click)="$event.stopPropagation()"
        aria-modal="true"
        [attr.aria-label]="contentComponent?.title ?? (contentComponent?.config?.title | translate) ?? null"
    >
        <ng-template #content></ng-template>
    </div>
    <!-- <div tabindex="0" style="position: absolute"></div> -->
</div>
